import React from "react";

const Auth = React.lazy(() => import("../views/Auth/index"));
const Feedback = React.lazy(() => import("../views/Feedback/index"));
const Roadmap = React.lazy(() => import("../views/Roadmap/index"));
const Updates = React.lazy(() => import("../views/Updates/index"));
const MagicLoginView = React.lazy(() => import("../views/MagicLogin/index"));
const PageView = React.lazy(() => import("../views/Page/index"));

const routes = {
  auth: {
    path: "/:portalSlug/auth",
    component: Auth,
    roles: [],
    exact: false,
    routes: {
      login: {
        exact: true,
        path: "/:portalSlug/auth/login",
      },
      register: {
        exact: true,
        path: "/:portalSlug/auth/register",
      },
    },
  },
  feedback: {
    path: "/:portalSlug/feedback",
    component: Feedback,
    roles: [],
    exact: true,
    showBackgroundImage: false,
  },
  roadmap: {
    path: "/:portalSlug/roadmap",
    component: Roadmap,
    roles: [],
    exact: true,
    showBackgroundImage: false,
  },
  updates: {
    path: "/:portalSlug/updates",
    component: Updates,
    roles: [],
    exact: true,
    showBackgroundImage: false,
  },
  page: {
    path: "/:portalSlug/page/:pageId/view",
    component: PageView,
    roles: ["USER"],
    exact: true,
    showBackgroundImage: false
  },
  magicLink: {
    path: "/:portalSlug/magic-link/:token",
    component: MagicLoginView,
    roles: [],
    exact: true,
  },
};

export default routes;
